import { reload_order_list_all } from "../http/OrderConn";
import { analyticeEvent } from "utils/Utils"

/**
 * 리스트 검색 영역 노출
 * @param rootStore
 */
export function fn_show_search_list(rootStore) {
    const searchStore = rootStore.searchStore;
    rootStore.searchStore.setSearchNoDataVal("SEARCH");
    searchStore.setSearchBarBl(true);                   // 검색영역 노출
    searchStore.setOrderSearchNoDataView(true);         // 하단 문구 노출
}

/**
 * 리스트 검색 영역 노출
 * @param rootStore
 */
export function fn_hide_search_list(rootStore) {
    const searchStore = rootStore.searchStore;
    rootStore.searchStore.setSearchNoDataVal("");
    searchStore.setSearchBarBl(false);                   // 검색영역 노출
    searchStore.setOrderSearchNoDataView(false);         // 하단 문구 노출
    rootStore.searchStore.setSearchVal('');
    fn_setListSearchKey(rootStore, 'mobileOrderNo', '채널 주문번호');
    reload_order_list_all(rootStore);

}

// 검색 키값 조회
export function fn_getListSearchKey(rootStore) {
    return rootStore.searchStore.getSearchKey;
}
// 검색 키값 설정
export function fn_setListSearchKey(rootStore, key, val) {
    rootStore.searchStore.setSearchKey(key, val);
    rootStore.searchStore.setOrderSearchView(false);
}

export function fn_getListOrderSearchView(rootStore) {
    return rootStore.searchStore.getOrderSearchView;
}

export function fn_setListOrderSearchView(rootStore, val) {
    return rootStore.searchStore.setOrderSearchView(val);
}

export function fn_setListSearchView(rootStore) {
    rootStore.searchStore.setToggleOrderSearchView();
}

export function fn_list_search(rootStore) {
    analyticeEvent("search", "searchQuick Button", rootStore.searchStore.getShopCd) //GA4
    rootStore.searchStore.setCurrStepType("all");
    rootStore.searchStore.setCurrOrderType("all");
    rootStore.searchStore.setSearchNoDataVal("SEARCH");
    rootStore.orderStore.setPagingInfo('page_no', 1);
    rootStore.orderStore.initOrderList();
    reload_order_list_all(rootStore);
}